module.exports = __webpack_public_path__ + "img/harvest3.96c2ce62.png";